import { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import {
	Column,
	Toast,
	Button,
	Dialog,
	InputText,
	InputTextarea,
	TabView,
	TabPanel,
	tabHeaderIIespanol,
	tabHeaderIIingles,
	Dropdown,
	Accordion,
	AccordionTab,
	Divider,
} from "../../components/crud";
import { Conexion } from "../../service/Conexion";
import {
	TablaDatos,
	BarraSuperior,
	EliminarVentana,
	productDialogFooter,
} from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { setDataSet, setFormData } from "../../store/appSlice";
import { Cargando } from "../../components/crud/Cargando";
import { QrReader } from "react-qr-reader";

// import { ImagenCampo } from "../../components/crud/ImagenCampo";
import { Leerqr } from "../../components/crud/Leerqr";
import { Carousel } from "primereact/carousel";

export const Hvequipos = () => {
	const TABLA = "equipos";
	let emptyFormData = {};
	const { dataSet, formData } = useSelector((state) => state.appsesion); //datos el storage redux
	const dispatch = useDispatch();
	const [productDialog, setProductDialog] = useState(false);
	const [deleteProductDialog, setDeleteProductDialog] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const toast = useRef(null);
	const [recargar, setrecargar] = useState(0);
	const [cargando, setCargando] = useState(false);
	const [dropdowvnClientes, setdropdowndropdowvnClientes] = useState(null);
	const [dropdowsino, setdropdowsino] = useState(null);
	const [listaEquiposparafiltro, setlistaEquiposparafiltro] = useState([]);
	const [qrData, setqrData] = useState([]);
	const [openqr, setopenqr] = useState(false);
	const [listaMantenimientos, setlistaMantenimientos] = useState([]);

	const datatable = new Conexion();
	// const [
	// 	dropdowvnDepartamentos,
	// 	setdropdowndropdowvnDepartamentos,
	// ] = useState(null);

	// const [
	// 	dropdowndropdowvntiposistema,
	// 	setdropdowndropdowvntiposistema,
	// ] = useState(null);
	// const [dropdowvnMunicipios, setdropdowvnMunicipios] = useState(null);
	// const [listaMunicipios, setlistaMunicipios] = useState(null);
	const [dropdowndropdowvnSedes, setdropdowndropdowvnSedes] = useState(null);
	const [
		dropdowndropdowvnSedesfilter,
		setdropdowndropdowvnSedesfilter,
	] = useState(null);

	const [
		dropdowndropdowvnubicacionesfilter,
		setdropdowndropdowvnubicacionesfilter,
	] = useState(null);

	const [
		dropdowndropdowvntipoequipo,
		setdropdowndropdowvntipoequipo,
	] = useState(null);
	const [
		dropdowndropdowvnubicacion,
		setdropdowndropdowvnubicacion,
	] = useState(null);
	let tituloiter = "Mantenimientos";

	useEffect(() => {
		// cargar la data total
		datatable
			.gettable("parametros/cliente")
			.then((menu) => setdropdowndropdowvnClientes(menu));
		datatable
			.gettable("parametros/sede")
			.then((menu) => setdropdowndropdowvnSedes(menu));
		datatable
			.gettable("parametros/ubicacion")
			.then((menu) => setdropdowndropdowvnubicacion(menu));
		datatable
			.gettable("parametros/tipoequipo")
			.then((menu) => setdropdowndropdowvntipoequipo(menu));
		datatable.gettable("parametros/parametros/sino").then((datos) => {
			setdropdowsino(datos);
		});
	}, []);

	useEffect(() => {
		//cargar la data total
		setCargando(true);
		dispatch(setFormData(emptyFormData));

		datatable.gettable(TABLA).then((data) => {
			dispatch(setDataSet(data));
			setlistaEquiposparafiltro(data);
			setCargando(false);
			// console.log(setDataSet);
		});
	}, [recargar]);

	useEffect(() => {
		let filtered = [];
		// console.log(formData);
		if (formData.cod_cli_equ) {
			// console.log({ dropdowndropdowvnSedes });
			filtered = dropdowndropdowvnSedes.filter(
				(item) => item.cod_cli_sed === formData.cod_cli_equ
			);
			// console.log({ filtered });
			// dispatch(setDataSet(filtered));
			setdropdowndropdowvnSedesfilter(filtered);
			// console.log(dropdowndropdowvnSedesfilter);

			console.log(dropdowndropdowvnubicacion);

			filtered = dropdowndropdowvnubicacion.filter(
				(item) => item.cod_cli_ubi === formData.cod_cli_equ
			);

			setdropdowndropdowvnubicacionesfilter(filtered);
		}

		// if (formData.selectSede) {
		// 	filtered = listaEquiposparafiltro.filter(
		// 		(item) => item.cod_sed_equ === formData.selectSede
		// 	);
		// 	dispatch(setDataSet(filtered));
		// }

		// if (formData.selectubucacion) {
		// 	filtered = listaEquiposparafiltro.filter(
		// 		(item) => item.cod_ubi_equ === formData.selectubucacion
		// 	);
		// 	dispatch(setDataSet(filtered));
		// }

		// console.log(filtered);
		// }, [formData.selectCliente, formData.selectSede, formData.selectubucacion]);
	}, [formData.cod_cli_equ]);

	useEffect(() => {
		if (qrData) {
			console.log({ qrData });
			let _product = { ...formData };
			_product[`qr_equ`] = qrData;
			dispatch(setFormData(_product));
			// setqrData(null);
			console.log({ _product });
			// console.log(formData);
			setopenqr(false);
		}
	}, [qrData]);

	/*eventos*/
	const openNew = () => {
		dispatch(setFormData(emptyFormData));
		setSubmitted(false);
		setProductDialog(true);
	};
	const hideDialog = () => {
		setSubmitted(false);
		setProductDialog(false);
	};

	const hideDeleteProductDialog = () => {
		setDeleteProductDialog(false);
	};

	// const editProduct = (id) => {
	// 	setCargando(true);
	// 	datatable
	// 		.getItem("parametros/agendamantenimiento", id)
	// 		.then((data) => {
	// 			setlistaMantenimientos(data.data)
	// 			dispatch(setFormData({ ...data.data })));}
	// 	setProductDialog(true);
	// 	setCargando(false);
	// };

	const editProduct = (id) => {
		setCargando(true); // Activa el estado de carga
		datatable.getItem("parametros/agendamantenimiento", id).then((data) => {
			setlistaMantenimientos(data.data);
			dispatch(setFormData({ ...data.data }));
			setProductDialog(true); // Abre el diálogo solo después de cargar los datos
			setCargando(false); // Desactiva el estado de carga
		});
	};

	const confirmDeleteProduct = (fila) => {
		dispatch(setFormData(fila));
		setDeleteProductDialog(true);
	};
	const openReedQR = () => {
		setqrData(null);
		setopenqr(true);
	};
	const trasaccionExitosa = (tipo = "") => {
		setrecargar(recargar + 1);
		tipo === "borrar" ? setDeleteProductDialog(false) : hideDialog();
		dispatch(setFormData(emptyFormData));

		toast.current.show({
			severity: "success",
			summary: "Confirmacion",
			detail: "Transacción Exitosa",
			life: 4000,
		});
	};

	/*eventos*/

	/**operacion transacciones */
	const saveProduct = () => {
		// console.log("save");
		console.log(formData);
		setSubmitted(true);
		if (formData.nom_equ?.trim()) {
			// console.log(formData);
			// debugger;
			setCargando(true);
			if (formData.id == null) {
				//nuevo registro
				datatable
					.getCrearItem(TABLA, formData)
					.then((data) => trasaccionExitosa());
			} else {
				//editar registro
				datatable
					.getEditarItem(TABLA, formData, formData.id)
					.then((data) => trasaccionExitosa());
			}
		}
	};
	const deleteProduct = () =>
		datatable
			.getEliminarItem(TABLA, formData, formData.id)
			.then((data) => trasaccionExitosa("borrar"));
	/**operacion transacciones */

	/* validaciones de campos */
	const onInputChange = (e, name) => {
		// console.log(e.target, e.target.value, name);
		const val = (e.target && e.target.value) || "";
		let _product = { ...formData };
		_product[`${name}`] = val;
		// _product[`${"tip_not"}`] = grupo; //solo para guardar noticias
		// console.log(_product);
		dispatch(setFormData(_product));
	};

	const actionBodyTemplate = (rowData) => {
		return (
			<div
				className='actions'
				style={{
					display: "flex",
				}}>
				<Button
					icon='pi pi-bars'
					className='p-button-rounded p-button-success mr-2'
					onClick={() => editProduct(rowData.id)}
				/>
				{/* <Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-warning mr-2'
					onClick={() => confirmDeleteProduct(rowData)}
				/> */}
			</div>
		);
	};

	const productTemplate = (product) => {
		// console.log(product);
		return (
			<div className='product-item'>
				<div className='product-item-content'>
					<div className='mb-1'>
						<img
							src={`${product.img_dal}`}
							onError={(e) =>
								(e.target.src =
									"https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")
							}
							alt={product.name}
							className='product-image'
						/>
					</div>
				</div>
			</div>
		);
	};

	const responsiveOptions = [
		{
			breakpoint: "480px",
			numVisible: 2,
			numScroll: 2,
		},
		{
			breakpoint: "480px",
			numVisible: 2,
			numScroll: 2,
		},
		{
			breakpoint: "480px",
			numVisible: 1,
			numScroll: 1,
		},
	];

	// const handleBurronQR = () => {
	// 	setopenqr(true);
	// };

	return (
		<div className='grid'>
			<div className='col-12'>
				<div className='card'>
					<Cargando cargando={cargando} />
					<Toast ref={toast} />
					{/* <BarraSuperior openNew={openNew} /> */}
					<div className='formgrid grid'>
						<div className='field col-4'>
							<label htmlFor='cod_teq_equ'>Cliente:</label>
							<Dropdown
								value={formData.selectCliente}
								onChange={(e) => {
									dispatch(
										setFormData({
											...formData,
											selectCliente: e.value,
										})
									);
								}}
								options={dropdowvnClientes}
								optionLabel='name'
								placeholder='Seleccione'
							/>
						</div>
						<div className='field col-4'>
							<label htmlFor='cod_teq_equ'>Sede:</label>
							<Dropdown
								value={formData.selectSede}
								onChange={(e) => {
									dispatch(
										setFormData({
											...formData,
											selectSede: e.value,
										})
									);
								}}
								// options={dropdowndropdowvnSedesfilter}
								optionLabel='name'
								placeholder='Seleccione'
							/>
						</div>
						<div className='field col-4'>
							<label htmlFor='cod_teq_equ'>Ubicacion:</label>
							<Dropdown
								value={formData.selectubucacion}
								onChange={(e) => {
									dispatch(
										setFormData({
											...formData,
											selectubucacion: e.value,
										})
									);
								}}
								options={dropdowndropdowvnubicacion}
								optionLabel='name'
								placeholder='Seleccione'
							/>
						</div>
					</div>
					<TablaDatos datostabla={dataSet} titulo={tituloiter}>
						<Column
							field='nom_equ'
							header='Nombre'
							sortable
							headerStyle={{
								width: "25%",
								minWidth: "10rem",
							}}></Column>

						<Column
							field='tipo_equipo'
							header='Tipo'
							sortable
							headerStyle={{
								width: "10%",
								minWidth: "10rem",
							}}></Column>

						<Column
							field='cliente'
							header='Cliente'
							sortable
							headerStyle={{
								width: "10%",
								minWidth: "10rem",
							}}></Column>

						<Column
							field='sede'
							header='Sede'
							sortable
							headerStyle={{
								width: "10%",
								minWidth: "10rem",
							}}></Column>
						<Column
							field='ubicacion'
							header='Ubicacion'
							sortable
							headerStyle={{
								width: "10%",
								minWidth: "10rem",
							}}></Column>

						<Column
							header='Acciones'
							body={actionBodyTemplate}></Column>
					</TablaDatos>

					<Dialog
						visible={productDialog}
						style={{ width: "850px" }}
						header={"Lista  " + tituloiter}
						modal={true}
						className='p-fluid'
						footer={productDialogFooter(hideDialog, saveProduct)}
						onHide={hideDialog}>
						<TabView>
							<TabPanel

							// headerTemplate={tabHeaderIIespanol}
							>
								{/* <pre>
									{JSON.stringify(listaMantenimientos, 2)}
								</pre> */}
								<Accordion
									className='accordion-custom'
									activeIndex={0}>
									{listaMantenimientos.map(
										(mantenimiento, index) => (
											<AccordionTab
												header={`${mantenimiento.fec_ama} - ${mantenimiento.cod_equ_ama}`}
												key={index}>
												<div className='formgrid grid'>
													<div className='field col-6'>
														<label htmlFor='cod_sed_equ'>
															Tipo:
															{
																mantenimiento.tip_ama
															}
														</label>
													</div>
													<div className='field col-6'>
														<label htmlFor='cod_sed_equ'>
															Status:
															{
																mantenimiento.sta_ama
															}
														</label>
													</div>
												</div>
												<div className='field col-12'>
													<label htmlFor='cod_sed_equ'>
														Anotacion:
														<p>
															{
																mantenimiento.des_ama
															}
														</p>
													</label>
												</div>
												<Divider></Divider>
												<div className='field col-12'>
													<label htmlFor='cod_sed_equ'>
														Imagenes:
														{mantenimiento.des_ama
															.length > 0 && (
															<div className='carousel-demo'>
																<div className='card'>
																	<Carousel
																		value={
																			mantenimiento.galeria
																		}
																		numVisible={
																			2
																		}
																		numScroll={
																			1
																		}
																		responsiveOptions={
																			responsiveOptions
																		}
																		itemTemplate={
																			productTemplate
																		}
																		circular={
																			true
																		}
																	/>
																</div>
															</div>
														)}
													</label>
												</div>
											</AccordionTab>
										)
									)}
								</Accordion>
								<Divider></Divider>

								{/* <div className='formgrid grid'>
									<div className='field col-6'>
										<label htmlFor='cod_sed_equ'>
											Sede:
										</label>
									</div>
									<div className='field col '>
										<label htmlFor='cod_ubi_equ'>
											Ubicacion:
										</label>
									</div>
								</div>

								<div className='formgrid grid'>
									<div className='field col-6'>
										<label htmlFor='cod_teq_equ'>
											Tipo Equipo:
										</label>
									</div>
									<div className='field col '>
										<label htmlFor='mar_equ'>Marca:</label>
									</div>
								</div>

								<div className='formgrid grid'>
									<div className='field col-6'>
										<label htmlFor='ser_equ'>Serial:</label>
									</div>
									<div className='field col-6'>
										<label htmlFor='mac_equ'>MAC:</label>
									</div>
								</div>

								<div className='formgrid grid'>
									<div className='field col-6'>
										<label htmlFor='rak_equ'>RACK:</label>
									</div>
									<div className='field col-6'>
										<label htmlFor='tab_equ'>
											Tablero:
										</label>
									</div>
								</div>
								<div className='formgrid grid'>
									<div className='field col-6'>
										<label htmlFor='pan_equ'>Panel:</label>
									</div>

									<div className='field col-6'>
										<label htmlFor='pro_equ'>Propio:</label>
									</div>
								</div> */}
							</TabPanel>
						</TabView>
					</Dialog>
					<EliminarVentana
						deleteProductDialog={deleteProductDialog}
						product={formData.nom_equ}
						hideDeleteProductDialog={hideDeleteProductDialog}
						deleteProduct={deleteProduct}
					/>
				</div>
			</div>
		</div>
	);
};
